import React from "react";

export interface TabsNavigation {
  activeIndex: number;
  tabsCount: number;
  goNext: () => void;
  goPrev: () => void;
  setTab: (index: number) => void;
}

export const TabsContext = React.createContext<TabsNavigation | null>(null);

export const useTabsNavigation = () => {
  const ctx = React.useContext(TabsContext);
  if (!ctx) {
    throw new Error("useTabsNavigation must be used inside <Tabs />");
  }
  return ctx;
};
